export function validateNzbnFormat(value: string): boolean {
	// remove all non-numeric characters from the NZBN
	const nzbn = value.replace(/[^0-9]/g, '');

	// Check if the NZBN contains exactly 13 digits
	if (nzbn.length !== 13) {
		return false;
	}

	// calculate the weighted Sum
	let sum = 0;
	const checkDigit = parseInt(nzbn[12], 10); // Convert character to number

	for (let i=0; i<12; i++) {
		const digit = parseInt(nzbn[i], 10); // Convert character to number
		const weight = (i + 1) % 2 === 0 ? 3 : 1;
		sum += (weight * digit);
	}

	// get the nearest equal or higher multiple of 10
	const nearestMultipleOfTen = Math.ceil(sum / 10) * 10;
	const checkDigitCalculated = nearestMultipleOfTen - sum;

	// Check if the check digit is correct
	return checkDigit === checkDigitCalculated;
}

export function validateAbnFormat(value: string): boolean {
	// Remove all non-numeric characters from the ABN
	const abn = value.replace(/[^0-9]/g, '');

	// Check if the ABN contains exactly 11 digits
	if (abn.length !== 11) {
		return false;
	}

	// ABN weighting array
	const abnWeighting = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19];

	// Calculate the weighted sum
	let sum = 0;
	for (let i = 0; i < 11; i++) {
		let digit = parseInt(abn[i], 10); // Convert character to number
		if (i === 0) {
			digit--; // Subtract 1 from the first digit
		}
		sum += abnWeighting[i] * digit;
	}

	// Check if the sum is divisible by 89
	if (sum % 89 !== 0) {
		return false;
	}

	return true;
}

export function validateAbnFormatWrapper(value: string): {
	isValid: boolean;
	value?: string;
} {
	// Remove all non-numeric characters from the ABN
	const abn = value.replace(/[^0-9]/g, '');
	const isValid = validateAbnFormat(abn);
	return {
		isValid,
		value: isValid ? abn : undefined
	}
}

export function validateAcnFormat(value: string, padLengthWithZeros: boolean = false): {
	isValid: boolean;
	value?: string;
} {
	// Remove all non-numeric characters from the ACN
	let acn = value.replace(/[^0-9]/g, '');

	// return false if the ACN has no-numeric characters
	if (acn.length === 0) {
		return {
			isValid: false
		};
	}

	// Check if the ACN has 9 digits or pad with zeros if required
	if (!padLengthWithZeros && acn.length !== 9) {
		return {
			isValid: false
		};
	}
	if (padLengthWithZeros) {
		acn = acn.padStart(9, '0');
	}

	// ACN weighting array
	const acnWeighting = [8, 7, 6, 5, 4, 3, 2, 1];

	// Calculate the weighted sum of the first 8 digits
	let sum = 0;
	for (let i = 0; i < 8; i++) {
		const digit = parseInt(acn[i], 10); // Convert character to number
		sum += acnWeighting[i] * digit;
	}

	// Calculate the check digit
	const remainder = sum % 10;
	const complement = 10 - remainder === 10 ? 0 : 10 - remainder;
	const checkDigit = parseInt(acn[8], 10);

	// Validate the ACN check digit
	if (checkDigit !== complement) {
		return {
			isValid: false
		};
	}

	return {
		isValid: true,
		value: acn
	}
}
